import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Philosophy } from "@/components/Philosophy";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { Reviews } from "@/components/Reviews";
import { Booking } from "@/components/Booking";
import { Location } from "@/components/Location";
import { Footer } from "@/components/Footer";

export default function Home() {
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    api.get("/config").then(({ data }) => {
      setServices(data.services);
      setSelectedService(data.services[0]?.id || null);
    }).catch(() => {});
  }, []);

  return (
    <div className="relative">
      <div className="pointer-events-none fixed inset-0 z-40 opacity-[0.035] mix-blend-overlay bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px]" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Philosophy />
        <Services services={services} onSelect={setSelectedService} />
        <Gallery />
        <Reviews />
        <Booking services={services} selectedService={selectedService} setSelectedService={setSelectedService} />
        <Location />
      </main>
      <Footer />
    </div>
  );
}
